import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { findOptionsForSelectFilter } from '../../util/search';
import config from '../../config';

import { ImageFromFile } from '../../components';

import SectionImages from '../../containers/ListingPage/SectionImages';
import SectionAvatar from '../../containers/ListingPage/SectionAvatar';
import SectionHeading from '../../containers/ListingPage/SectionHeading';
import SectionDescriptionMaybe from '../../containers/ListingPage/SectionDescriptionMaybe';
import SectionShortDescriptionMaybe from '../../containers/ListingPage/SectionShortDescriptionMaybe';

import OtherInfoSection from '../../containers/ListingPage/OtherInfoSection/OtherInfoSection';
import PostsSection from '../../containers/ListingPage/PostsSection/PostsSection';
import YoutubeSection from '../../containers/ListingPage/YoutubeSection/YoutubeSection';
import FilesSection from '../../containers/ListingPage/FilesSection/FilesSection';

import css from './PreviewPopup.module.css';

export const PreviewPopup = props => {

  const {
    intl,
    currentUser,
    listingData,
    listing,
    onManageDisableScrolling,
    isDraft,
    onHandleClosePopup,
    onHandleCreateAndBublishListing
  } = props;

  const isProvider = currentUser?.attributes?.profile?.publicData?.userType === 'service-provider';

  const { values = {}, images = [], isDescriptionTab=false } = listingData || {};
  const { publicData = {} } = listing?.attributes || {};

  const title = values?.title || listing?.attributes?.title
  const description = values?.description || listing?.attributes?.description;

  const customDisplayName = !!values?.useDisplayName?.[0] && `${values?.displayName} ${values?.displaySurname} - ${title}` || publicData?.customDisplayName;

  const subcategoryPriceValuesArr = values?.subcategory?.map((item, i) => {
    const subcategoryOptions = findOptionsForSelectFilter('subcategory', config.custom.filters);
    const parentCategory = subcategoryOptions.filter(subCat => subCat.key === item)?.[0]?.category;

    return {
      key: values?.subcategory[i],
      parentCategory
    }
  })
  const subcategoryPriceValues = subcategoryPriceValuesArr || publicData?.subcategoryPriceValues;

  const listingValues = {
    listingType: isProvider ? 'provider' : 'client',
    useDisplayName: values?.useDisplayName || publicData?.useDisplayName,
    displayName: values?.displayName || publicData?.displayName,
    displaySurname: values?.displaySurname || publicData?.displaySurname,
    customDisplayName,
    shortDescription: values?.shortDescription || publicData?.shortDescription,
    website: values?.website || publicData?.website,
    address: values?.address || publicData?.address,
    phoneNumber: values?.phoneNumber || publicData?.phoneNumber,
    productType: values?.productType || publicData?.productType,
    providerType: values?.providerType || publicData?.providerType,
    startupAsk: values?.startupAsk || publicData?.startupAsk,
    fundingStatus: values?.fundingStatus || publicData?.fundingStatus,
    category: values?.category || publicData?.category,
    subcategory: values?.subcategory || publicData?.subcategory,
    subcategoryPriceValues,

    legalOtherDescription: values?.legalOtherDescription || publicData?.legalOtherDescription,
    marketingOtherDescription: values?.marketingOtherDescription || publicData?.marketingOtherDescription,
    insuranceOtherDescription: values?.insuranceOtherDescription || publicData?.insuranceOtherDescription,
    accountingOtherDescription: values?.accountingOtherDescription || publicData?.accountingOtherDescription,
    consultingOtherDescription: values?.consultingOtherDescription || publicData?.consultingOtherDescription,
    startupOtherDescription: values?.startupOtherDescription || publicData?.startupOtherDescription,

    geographicalFocus: values?.geographicalFocus || publicData?.geographicalFocus,
    companySize: values?.companySize ? [values.companySize] : publicData?.companySize,
    operatingSince: values?.operatingSince ? [values.operatingSince] : publicData?.operatingSince,
    questions: values?.questions || publicData?.questions,
    paymentMethod: values?.paymentMethod || publicData?.paymentMethod,
    whatAreYouLookingFor: values?.whatAreYouLookingFor || publicData?.whatAreYouLookingFor,
    differentiationFromCompetitors: values?.differentiationFromCompetitors || publicData?.differentiationFromCompetitors,
    associationTitle: values?.associationTitle || publicData?.associationTitle,
    associations: values?.associations?.filter(a => !!a) || publicData?.associations || null,
    qualificationTitle: values?.qualificationTitle || publicData?.qualificationTitle,
    qualifications: values?.qualifications?.filter(q => !!q) || publicData?.qualifications || null,
    files: values?.files?.filter(f => !!f) || publicData?.files || null,
    videos: values?.videos || publicData?.videos,

    news: values?.news || publicData?.news,
    content: values?.content || publicData?.content,
    events: values?.events || publicData?.events,
  }

  const isOwnListing = true
  const isProviderListing = listingValues?.listingType !== 'client';

  const hasSavedLogo = currentUser?.profileImage?.id?.uuid;
  const uploadedLogo = images?.filter(
    img => typeof img.id === 'string' && img.id?.includes('logoPhoto-')
    )?.[0];


  const isClient = currentUser?.attributes?.profile?.publicData?.userType === 'client';

  // const hasSavedBanner = currentUser?.profileImage?.id?.uuid;
  const hasSavedBanner = false;
  const uploadedBanner =
    typeof images?.[0]?.id === 'string' &&
    images?.[0]?.id?.includes('backgroundPhoto-') &&
    images?.[0];

  return (
    <div className={css.root}>

      {!!uploadedBanner ? (
        <div className={css.sectionImages}>
          <div className={css.threeToTwoWrapper}>
            <div className={css.aspectWrapper}>
              <ImageFromFile
                id={uploadedBanner.id}
                rootClassName={css.rootForImage}
                file={uploadedBanner.file}
              >
              </ImageFromFile>
            </div>
          </div>
        </div>
      ) : (
        <SectionImages
          listing={listing}
          intl={intl}
          isOwnListing={true}
          imageCarouselOpen={false}
          onImageCarouselClose={() => { }}
          handleViewPhotosClick={() => { }}
          onManageDisableScrolling={onManageDisableScrolling}
          isPreview
        />
      )}
      <div className={css.contentContainer}>
        {!!uploadedLogo && isDescriptionTab ? (
          <div className={css.sectionAvatar}>
            <div className={css.avatarDesktop}>
              <ImageFromFile
                id={uploadedLogo.id}
                rootClassName={css.thumbnail}
                file={uploadedLogo.file}
                isPreview
              >
              </ImageFromFile>
            </div>
            <div className={css.avatarMobile}>
              <ImageFromFile
                id={uploadedLogo.id}
                rootClassName={css.thumbnail}
                file={uploadedLogo.file}
                isPreview
              >
              </ImageFromFile>
            </div>
          </div>
        ) : <SectionAvatar user={currentUser} /> }

        <div className={css.mainContent}>
          <SectionHeading
            richTitle={title}
            currentListing={listing}
            publicData={listingValues}
          />
          <SectionShortDescriptionMaybe publicData={listingValues} />
          <SectionDescriptionMaybe description={description} />
          <OtherInfoSection
            listing={listing}
            publicData={listingValues}
            intl={intl}
            isProviderListing={isProviderListing}
          />
          <FilesSection
            files={listingValues?.files}
            label='Documents'
            labelClassName={css.filesTitle}
            showAsSwiper
            isPreview
            intl={intl}
          />
          <PostsSection
            listing={listing}
            publicData={listingValues}
            isOwnListing={isOwnListing}
            onManageDisableScrolling={onManageDisableScrolling}
            isPreview
            intl={intl}
          />
          <YoutubeSection
            publicData={listingValues}
            listing={listing}
            isOwnListing={isOwnListing}
            onManageDisableScrolling={onManageDisableScrolling}
            intl={intl}
            isPreview
          />
        </div>

        <div className={css.bookingPanel}>
          <div
            className={css.actionButton}
            onClick={() => alert(intl.formatMessage({ id: 'PreviewPopup.previewMode' }))}
          >
            <FormattedMessage id="ListingPage.contact" />
          </div>
          <div
            className={css.actionButton}
            onClick={() => alert(intl.formatMessage({ id: 'PreviewPopup.previewMode' }))}
          >
            <FormattedMessage id="ListingPage.requestForQuote" />
          </div>
        </div>
      </div>

      <div className={css.popupButtons}>
        {(isDraft || !listing) ? (
          <div
            className={css.popupButton}
            onClick={onHandleCreateAndBublishListing}
          >
            <FormattedMessage id="PreviewPopup.publish" />
          </div>
        ) : <div className={css.popupButtonSpaceHolder} />}
        <div
          className={css.popupButton}
          onClick={onHandleClosePopup}
        >
          <FormattedMessage id="PreviewPopup.keepEditing" />
        </div>
      </div>
    </div>
  );
}

export default PreviewPopup;
